import React, { useRef, useState } from 'react';
import { useForm } from 'react-hook-form';
import YFinput from '../elements/YFInput';
import { submitChangePassword } from '../../api';
import { Row, Col, message } from 'antd';
import Loading from '../../components/Loading';
import useApplicationSession from '../../session/UserSession';

const ChangePasswordForm = () => {
    const { handleSubmit, register, errors, watch, reset } = useForm();
    const password = useRef({});
    password.current = watch('password', '');
    const token = useApplicationSession();

    const [loading, setLoading] = useState(false);

    const onSubmit = (value) => {
        setLoading(true);
        submitChangePassword({ request: value, token: token })
            .then((response) => {
                message.success(response.message);
                setLoading(false);
                reset('password');
                reset('password_confirmation');
            })
            .catch((error) => {
                message.error('Change password failed.');
                setLoading(false);
            });
    };

    return (
        <form className="passwordChangeContainer" onSubmit={handleSubmit(onSubmit)}>
            <h3 className="contactUsTitle">Change Password</h3>
            <Row>
                <Col
                    xs={{ span: 24 }}
                    sm={{ span: 24 }}
                    md={{ span: 24 }}
                    lg={{ span: 24 }}
                    xl={{ span: 24 }}
                    xxl={{ span: 24 }}
                    className="horizontal-container-element"
                >
                    <YFinput
                        name="password"
                        type="password"
                        label="Password"
                        auto_complete="new-password"
                        placeholder="Enter Password"
                        register={register({
                            required: 'You must specify a password',
                            minLength: {
                                value: 8,
                                message: 'Password must have at least 8 characters',
                            },
                        })}
                    />
                    {errors.password && <p className="formFieldError">{errors.password.message}</p>}
                </Col>
            </Row>
            <Row>
                <Col
                    xs={{ span: 24 }}
                    sm={{ span: 24 }}
                    md={{ span: 24 }}
                    lg={{ span: 24 }}
                    xl={{ span: 24 }}
                    xxl={{ span: 24 }}
                    className="horizontal-container-element"
                >
                    <YFinput
                        name="password_confirmation"
                        type="password"
                        label="Confirm Password"
                        auto_complete="new-password"
                        placeholder="Enter Confirm Password"
                        register={register({
                            validate: (value) => value === password.current || 'The passwords do not match',
                        })}
                    />
                    {errors.password_confirmation && (
                        <p className="formFieldError">{errors.password_confirmation.message}</p>
                    )}
                </Col>
            </Row>

            <>{loading ? <Loading /> : <input className="submitBtn" type="submit" label="Submit" />}</>
        </form>
    );
};

export default ChangePasswordForm;
